var map = {
	"./Body.vue": 3388,
	"./Btn.vue": 2787,
	"./DialogCam.vue": 5966,
	"./DialogDel.vue": 3713,
	"./DialogImg.vue": 4264,
	"./Heading.vue": 6935,
	"./Img.vue": 7682,
	"./Section.vue": 5658,
	"./Subheading.vue": 4962,
	"./Subtitle.vue": 1451,
	"./Title.vue": 2945
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8873;